import React from 'react';
import { Table, Button} from 'semantic-ui-react';
import * as qs from "query-string";
import {NoData} from "../../components/table/no-data";
import {Link, withRouter} from "react-router-dom";
import {translateSiteName} from "../../helpers/data-helpers";

class SiteTableRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = { params: qs.parse(this.props.location.search)};
}



  render() {
    const { selected, data, onRowSelect } = this.props;

  
    return (
      <Table.Row
      onClick={() => onRowSelect(data.siteKey)}
      negative={selected}

    
    //  style={{ backgroundColor: selected ? '#7ABF80' : 'none' }} 
    >        
          <Table.Cell>{ translateSiteName(this.props.data) || <NoData/>}</Table.Cell>
        <Table.Cell>{this.props.data.town || <NoData/>}</Table.Cell>
        <Table.Cell>{this.props.data.postcode || <NoData/>}</Table.Cell>
        <Table.Cell>{this.props.data.siteStatus || <NoData/>}</Table.Cell>
        <Table.Cell>{this.props.data.locationId || <NoData/>}</Table.Cell>
        <Table.Cell>
         {this.state.params.meterReadMode === undefined ?

            <Link to={ { pathname: '/site',
                search: `siteKey=${this.props.data.siteKey}`}
                 }>
                <Button basic >Site Details</Button>
            </Link>
            :
            <Link to={ { pathname: '/site',
            search: `siteKey=${this.props.data.siteKey}&meterReadMode=1`}
             }>
            <Button basic >Site Details</Button>
        </Link>
        }

        </Table.Cell>
      </Table.Row>
    );
  }
}

export default withRouter(SiteTableRow)